<div class="number-filter">
  <div class="number-filter-counter">
    <span>{{ resultsCounter }}&nbsp;</span>
    <span translate="results"></span>
  </div>

  <app-task-list-sort
    *ngIf="sortId !== null"
    [taskListConfiguration]="taskListConfiguration"
    [taskListMode]="taskListMode"></app-task-list-sort>

  <ng-container *ngIf="searchFiltersMap.size">
    <mat-chip-list class="search-filters">
      <ng-container *ngFor="let item of searchFiltersMap | keyvalue">
        <ng-container *ngIf="item.value as searchFilter">
          <mat-chip [selected]="true" (removed)="searchFilter.clearFn()">
            {{ searchFilter.label }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </ng-container>
      </ng-container>
    </mat-chip-list>
  </ng-container>
</div>

<app-task-list
  [taskListConfiguration]="taskListConfiguration"
  [taskListMode]="taskListMode"
  (tasksIdsLengthChange)="updateResultsCounter($event)"></app-task-list>
